var baseUrl = window.location.origin;
import firebase from '@/firebase'
const db = firebase.firestore()
import { FS_COLLECTIONS } from '@/firebase'
import { TIPO_PERFIL, STATUS_APP } from '@/constantes/usuarios.js'
import { ESPECIES_BASE_OBJ } from '@/constantes/especies.js'
import { PRODUCTOS_BASE_OBJ } from '@/constantes/productos.js'
import { ROLES_BASE_OBJ } from '@/constantes/rol.js'
import { SERVICIOS_BASE_OBJ } from '@/constantes/servicios.js'
import { SERVICIOS_BASE_INICIAL } from '@/constantes/servicios.js'
import { COLORES, ESPACIOS, CAJAS} from '@/constantes/catalogosIniciales.js'
import { ESTUDIOS_BASE_OBJ } from '@/constantes/estudios.js'
//import { DESCRIPCION_SERVICIOS_BASE_OBJ } from '@/constantes/descripcion_servicios.js'
var cargadorCatalogosPacientes = null
var cargadorUsuario = null
const store = {
  state: {
    usuario: null,
    usuario_token: null,
    perfil: null,
    statusApp: '',
    cargando_componente:false,
    loading_aviso: false,
  },
  getters: {
    cargando_componente:state => {
      return state.cargando_componente
    },
    loading_aviso:state => {
      return state.loading_aviso
    },
    usuario: state => {
      return state.usuario
    },
    usuario_token: state => {
      return state.usuario_token
    },
    sucursalActual: state => {
      if (state.usuario === null) {
        return ''
      }
      return state.usuario.sucursal_actual
    },
    nombreCompleto(state) {
      if (state.usuario === null) {
        return ''
      }
      return state.usuario.info.nombre + ' ' + state.usuario.info.apellidos
    },
    perfil(state) {
      return state.perfil
    },
    statusApp(state) {
      return state.statusApp
    },
  },
  mutations: {
    setLoading (state, payload) {
      state.loading_aviso = payload
    },
    ASIGNA_CARGANDO_COMPONENTE(state,cargando){
      state.cargando_componente = cargando
    },
    ASIGNA_USUARIO(state, usuario) {
      state.usuario = usuario
    },
    ASIGNA_USUARIO_TOKEN(state, usuario_token) {
      state.usuario_token = usuario_token
    },
    ASIGNA_PERFIL(state, perfil) {
      state.perfil = perfil
    },
    ASIGNA_STATUS_APP(state, statusApp) {
      state.statusApp = statusApp
    },
    login(state, usuario) {
      state.usuario = usuario
    }
  },
  actions: {
    modalCargandoAviso({commit}, status){
      commit('setLoading', status)
    },
    loginCorreo({ commit, dispatch }, credenciales) {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signInWithEmailAndPassword(credenciales.email, credenciales.password)
          .then(response => {
            let user = response.user
            console.log('user.uid loging correo: ' + user.uid)
            
            /*.catch(error => {
              console.error('Error obteniendo UsuarioToken: ', error)
              reject(error)
            });*/

            dispatch('cargaInicialUsuario', user.uid)
              .then((res) => {
                console.log("TCL: loginCorreo -> e", res)
                console.log('SE LOGUEO BIEN TODO BIEN BIEN BIEN');


                if(res.tiene_aviso){
                  console.log('TCL: tieneAvisoPixan Si tiene_aviso')
                  if(res.tiene_aviso !== 2){
                    //set Mostrar Modal
                    //this.modalCargandoAviso(true);
                    dispatch('modalCargandoAviso', true);
          
                    //set aumentar contador a +1
                    res.tiene_aviso = res.tiene_aviso+1;
                    //this.actualizarUsuario(res)
                    dispatch('actualizarUsuario', res);
                  }
                }else{
                  console.log('TCL: tieneAvisoPixan No tiene_aviso')
                  //set Mostrar Modal
                  //this.modalCargandoAviso(true);
                  dispatch('modalCargandoAviso', true);
          
                  //set aumentar contador a 1
                  res.tiene_aviso = 1;
                  //this.actualizarUsuario(res)
                  dispatch('actualizarUsuario', res);
                }

                resolve(res)
              })
              .catch(error => {
                console.error('Error obteniendo Usuario: ', error)
                reject(error)
              })
          })
          .catch(error => {
            console.error('Error firmando Usuario: ', error)
            reject(error)
          })
      })
    },
    cargaInicialUsuario({ dispatch, commit }, uid) {
      
      //if(localStorage.flagLogin !== undefined ){
        localStorage.removeItem('flagLogin');
      //}
      

      console.log('cargaInicialUsuario: ' + uid)
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.PERFILES)
          .doc(uid)
          .get()
          .then(doc => {
            commit('ASIGNA_PERFIL', doc.data())
            //
            let p = doc.data()
            //console.log(p)
            if (p.tipo === TIPO_PERFIL.USUARIO) {
              dispatch('cargaInicialToken', uid)
              .then(() => {

                dispatch('cargaUsuario', uid).then((resolvce) => {
                  commit('ASIGNA_STATUS_APP', STATUS_APP.ACTIVA)
                  resolve(resolvce)
                })
                
              }).catch(error => {
                console.error('Error cargaInicialToken: ', error)
                reject(error)
              })

              
            }else{
              if (p.tipo === 'Empleado') {
                dispatch('cargarEmpleado', uid).then(() => {
                  commit('ASIGNA_STATUS_APP', STATUS_APP.ACTIVA)
                  resolve()
                })
              }
              if (p.tipo === 'Propietario') {
                console.error('Los propietarios no se pueden loguear en la app')
                dispatch("desconectarse");
                reject({code: "auth/tipo-propietario", message: "Texto hardcode"})
              }
            }
          })
          .catch(error => {
            console.error('Error obteniendo Perfil: ', error)
            reject(error)
          })
      })
    },
    cargaInicialToken({ dispatch, commit }, uid) {
      //console.log('cargaInicialToken: ', uid)
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.USUARIOS)
          .doc(uid)
          .get()
          .then(doc => {
            let userDatos = doc.data();
            console.log("TCL: cargaInicialToken -> userDatos", userDatos)
            var rand = function() {
              return Math.random().toString(36).substr(2); // remove `0.`
            }; var token = function() {
              return rand() + rand(); // to make it longer
            };


            //Si el usuario tiene rol de responsable no puede loggearse 27nov2019
            if(userDatos.info.cargo == 'responsable'){
              dispatch("desconectarse");
              console.log("TCL: tiene acceso de RESPONSABLE NO TIENE ACCESO");
              //reject('auth/tipo-responsable')
              reject({code: "auth/tipo-responsable", message: "Texto hardcode"})
            }

            if(userDatos == undefined){
              dispatch("desconectarse");
              console.log("redig¡rir a loging");
              //reject('auth/user-not-found')
              reject({code: "auth/user-not-found", message: "Texto hardcode"})
            }else{
            
           
              //console.log('TCL: -----ENTRO PARA CARGAR TOKEN-----')
              //console.log("TCL: cargaUsuario -> localStorage", localStorage.token_dispositivo)
              //console.log("TCL: cargaUsuario -> DadaBase", userDatos.info_complementaria.token_dispositivo)

              if(localStorage.token_dispositivo !== userDatos.info_complementaria.token_dispositivo || userDatos.info_complementaria.token_dispositivo == undefined){
                //console.log('TCL: -----ENTRO SON DIFERENTES TOKEN LOCAL Y DB-----')
                //************************ Se actualiza el token del user para 1 solo logueo */
                userDatos.info_complementaria.token_dispositivo = token();
                localStorage.token_dispositivo = userDatos.info_complementaria.token_dispositivo;
                //console.log("TCL: cargaUsuario -> NuevouserDatos", userDatos.info_complementaria.token_dispositivo)
                //console.log("TCL: cargaUsuario -> Nuevotoken_dispositivo", localStorage.token_dispositivo)
                
                db
                .collection('Usuarios')
                .doc(userDatos.id)
                .update({
                  ...userDatos
                })

              }

              const expirationDuration = 1000 * 60 * 5; // 5 MINUTOS
                const prevAccepted = localStorage.getItem("accepted");
                console.log("TCL: cargaInicialToken -> prevAccepted", prevAccepted)
                const currentTime = new Date().getTime();
                const notAccepted = prevAccepted == undefined;
                const prevAcceptedExpired = prevAccepted != undefined && currentTime - prevAccepted > expirationDuration
                if (notAccepted || prevAcceptedExpired) {
                  console.log("TCL: EL TIMEPO DE LA VARIABLE LOCAL CADUCO");
                  //localStorage.setItem("accepted", currentTime);

                  firebase
                  .auth()
                  .signOut()
                  .then(() => {
                    commit('login', null)
                    window.location.href = baseUrl;
                    resolve('cerrado_correctamente')
                  })
                  .catch(error => reject(error))

                }
                

              commit('ASIGNA_USUARIO_TOKEN', userDatos.info_complementaria.token_dispositivo)
              resolve()
            }
        }).catch(error => {
          console.error('Error obteniendo CargaTooken: ', error)
          reject(error)
        })
      })
    },
    cargarEmpleado({ dispatch, commit }, uid){
      return new Promise((resolve, reject) => {
        if (cargadorUsuario === null) {
          let docUsuario = db.collection(FS_COLLECTIONS.EMPLEADOS).doc(uid)
          cargadorUsuario = docUsuario.onSnapshot(
            doc => {
              commit('ASIGNA_USUARIO', doc.data())
              dispatch('cargaFranquicia', doc.data().franquicia).then(() => {
                resolve()
              })
            },
            error => {
              console.error('Error obteniendo Empleado: ', error)
              reject(error)
            }
          )
        } else {
          resolve()
        }
      })
    },
    cargaUsuario({ dispatch, commit }, uid) {
      return new Promise((resolve, reject) => {
        if (cargadorUsuario === null) {
          let docUsuario = db.collection(FS_COLLECTIONS.USUARIOS).doc(uid)
          cargadorUsuario = docUsuario.onSnapshot(
            doc => {
              commit('ASIGNA_USUARIO', doc.data())
              dispatch('cargaFranquicia', doc.data().id_franquicia).then(() => {
                resolve(doc.data())
              })
            },
            error => {
              console.error('Error obteniendo Usuario: ', error)
              reject(error)
            }
          )
          /* .catch(error => {
              console.error('Error obteniendo Usuario: ', error)
              reject(error)
            }) */
        } else {
          resolve()
        }
      })
    },
    recuperarPassword({}, email) {
      return firebase.auth().sendPasswordResetEmail(email)
    },
    desconectarse({ commit }) {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signOut()
          .then(() => {
            commit('login', null)
            resolve('cerrado_correctamente')
          })
          .catch(error => reject(error))
      })
    },
    crearComplementoUsuario({ commit, dispatch }, nuevoUsuario) {
      commit('ASIGNA_STATUS_APP', STATUS_APP.CONFIGURACION_INICIAL)
      
      var datosUsuario = {
        info: {
          cargo: 'OvrJ0058hSeji0Xe8dDo',
          nombre: nuevoUsuario.nombreCompleto,
          apellidos: nuevoUsuario.apellidos,
          esAdmin: true,
         
          fecha_alta: new Date()
        },
        info_complementaria: {
          id_caja_actual: null,
          id_corte_actual: null
        },
        direccion: {
          pais: nuevoUsuario.pais
        },
        creado_esquenda: nuevoUsuario.creado_esquenda,
        estatus: { estatus: 'Activo' },
        email: nuevoUsuario.email,
        estatus_pago:{
          estatus: null,
          fecha_pago: null,
          id_suscripcion: null,
          plan: null,
          recurrente: false,
          ya_uso_premium: false,
          pruebas: false
        }
      }
      if(!nuevoUsuario.creado_esquenda){
        nuevoUsuario.creado_esquenda = false;
        datosUsuario = {
          info: {
            cargo: 'OvrJ0058hSeji0Xe8dDo',
            nombre: nuevoUsuario.nombreCompleto,
            apellidos: nuevoUsuario.apellidos,
            esAdmin: true,
            telefonos: { Celular: nuevoUsuario.celular },
            fecha_alta: new Date()
          },
          info_complementaria: {
            id_caja_actual: null,
            id_corte_actual: null
          },
          direccion: {
            pais: nuevoUsuario.pais
          },
          creado_esquenda: nuevoUsuario.creado_esquenda,
          estatus: { estatus: 'Activo' },
          email: nuevoUsuario.email,
          estatus_pago:{
            estatus: null,
            fecha_pago: null,
            id_suscripcion: null,
            plan: null,
            recurrente: false,
            ya_uso_premium: false,
            pruebas: false
          }
        }
      }
      
      //delete nuevoUsuario.password
      var datosCorporativo = {
        nombre: 'Nuevo Corporativo',
        administrador: nuevoUsuario.uid,
        limiteUsuarios: 0,
        estatus_pago: true,
        foto:{nombre:'',url:'',base64:''},
      }
      return db
        .collection(FS_COLLECTIONS.CORPORATIVOS)
        .add(datosCorporativo)
        .then(docRef => {
          datosUsuario.id_corporativo = docRef.id
          datosUsuario.rol = 'Admin'
          datosUsuario.foto = ''
          datosUsuario.id = nuevoUsuario.uid
          datosCorporativo.id = docRef.id
          return db
            .collection(FS_COLLECTIONS.USUARIOS)
            .doc(nuevoUsuario.uid)
            .set(datosUsuario)
        })

        .then(() => {
          let docRefFranquicia = db.collection(FS_COLLECTIONS.FRANQUICIAS)

          return docRefFranquicia.add({
            id_corporativo: datosCorporativo.id,
            foto:{url:'',base64:'',nombre:''},
            nombre: 'Nueva Franquicia',
            id_ultimo_ticket:1,
          })
        })
        .then(docRefFranquicia => {
          console.log('docRef: ' + datosCorporativo.id)

          /*********************
           * Se mudó la creación de catalogos al método crearCatalogosFranquicia para reutilizarlo *
           * ****************/
          let payloadFranquicia = {
            idFranquicia: docRefFranquicia.id,
            usuario: datosUsuario
          }
          dispatch('crearCatalogosFranquicia', payloadFranquicia).then(
            idSucursal => {
              let updateUser = {
                id_franquicia: docRefFranquicia.id,
                sucursal_actual: idSucursal,
                info_complementaria: {
                  sucursales: [idSucursal],
                  token_dispositivo: null,

                  id_caja_actual: null,
                  id_corte_actual: null
                }
              }
              // Actualizamos los id para facilitarnos la vida
              docRefFranquicia.update({ id: docRefFranquicia.id })
              db.collection(FS_COLLECTIONS.USUARIOS)
                .doc(nuevoUsuario.uid)
                .update(updateUser)
            }
          )

          let docRefPerfiles = db
            .collection(FS_COLLECTIONS.PERFILES)
            .doc(nuevoUsuario.uid)
          console.log('perfil 0: ')
          console.log(docRefPerfiles)
          return docRefPerfiles.set({
            id: nuevoUsuario.uid,
            id_corporativo: datosCorporativo.id,
            tipo: TIPO_PERFIL.USUARIO,
            es_admin: true,
            es_empleado: false,
            estatus: 'Activo'
            //id_franquicia: docRefFranquicia.id
          })
        })
        .then(() => {
          return
        })
        .catch(error => {
          console.error('Error creando complementos: ', error)
        })
    },
    crearCatalogosFranquicia({}, payloadFranquicia) {
      return new Promise(resolve => {
        console.log('crearCatalogos idFranquicia: ' + idFranquicia)

        //Obtenemos la referencia a la Colección de catalogos
        let idFranquicia = payloadFranquicia.idFranquicia
        let us = payloadFranquicia.usuario
        let refFranquicia = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(idFranquicia)
        let refCatalogos = refFranquicia.collection(FS_COLLECTIONS.CATALOGOS)

        

        console.log('id franquicia: ' + idFranquicia)

        //Creamos una Sucursal con los valores que traemos del usuario
        let sucursal = {
          id_franquicia: idFranquicia,
          usuario_padre: us.id,
          info: {
            nombre: 'Sucursal Matriz',
            estatus: 'activo',
            correo: us.email,
            telefono: '(55)5555 5555'
          },
          estatus: {
            estatus: 'activo',
            fecha_baja: '',
            motivos_baja: ''
          },
          configuracion_agenda:{
            duracion_citas: 15, 
            tiempo_espera: 5
          },
          cajas_abiertas:[],
          direccion: {pais: '', estado:''},
          datos_fiscales: { estado: '', pais: '' },
          estatus_pago: {tipo: 'gratuito'}

        }

        db.collection(FS_COLLECTIONS.SUCURSALES)
          .add(sucursal)
          .then(refSucursal => {
            // Actualizamos el id de sucursal para facilitarnos la vida en las cloudFunctions
            db.collection(FS_COLLECTIONS.SUCURSALES)
              .doc(refSucursal.id)
              .update({
                id: refSucursal.id
              })

            let refSucursales = db
            .collection(FS_COLLECTIONS.SUCURSALES)
            .doc(refSucursal.id)
            let refSucursalesIndices = refSucursales.collection(FS_COLLECTIONS.INDICES)
            //Creamos una lista de agendas a nivel sucursal
            let agendas = refSucursalesIndices.doc(FS_COLLECTIONS.AGENDA)
            agendas.set({ dataSource: [] })

            //Creamos una lista de especies a nivel franquicia
            let especies = refCatalogos.doc(FS_COLLECTIONS.ESPECIES)
            especies.set(ESPECIES_BASE_OBJ.ESPECIES)

            //Creamos una lista de productos a nivel franquicia
            let productos = refCatalogos.doc(FS_COLLECTIONS.PRODUCTOS)
            productos.set(PRODUCTOS_BASE_OBJ.PRODUCTOS)

            //Asignamos un producto de la lista de productos a nivel franquicia
            let productoBase = PRODUCTOS_BASE_OBJ.PRODUCTO;
            productoBase.compartir.en_sucursales[refSucursal.id] = true;
            let producto = refFranquicia
              .collection(FS_COLLECTIONS.PRODUCTOS)
              .doc('OvrJ0058hSeji0Xe8dTo')
            producto.set(productoBase)

            //Asignamos un ROL ADMIN de la lista de roles a nivel franquicia
            let rolAdminBase = ROLES_BASE_OBJ.ROL;
            let rol = refFranquicia
              .collection(FS_COLLECTIONS.ROLES)
              .doc('OvrJ0058hSeji0Xe8dDo')
            rol.set(rolAdminBase)

            //Creamos una lista de servicios a nivel franquicia
            let servicios = refCatalogos.doc(FS_COLLECTIONS.SERVICIOS)
            servicios.set(SERVICIOS_BASE_OBJ)

            var serviciosBase = SERVICIOS_BASE_INICIAL
            console.log('Servicio padre')
            console.log(serviciosBase)
            console.log('ID de los servicios')
            for (var k in serviciosBase) {
              console.log(k)

              let servicio = refFranquicia
                .collection(FS_COLLECTIONS.SERVICIOS)
                .doc(k)

              var servicioConsulta = serviciosBase[k]
              servicioConsulta.compartir.en_sucursales[refSucursal.id] = true
              // TODO: Buscar como no duplicar el dato de sucursales
              servicioConsulta.sucursal = [
                { id: refSucursal.id, nombre: sucursal.info.nombre }
              ]
              servicio.set(servicioConsulta)
            }
            //Creamos una lista de espacios a nivel franquicia
            let refEspacios = refCatalogos.doc(FS_COLLECTIONS.ESPACIOS)
            let espacios = ESPACIOS
            espacios.Espacios[0].sucursal = {
              id: refSucursal.id,
              nombre: sucursal.info.nombre
            }
            espacios.Espacios[0].id_temporal='0'
            refEspacios.set(espacios)

            //Creamos una lista de cajas a nivel franquicia
            let refCajas = refCatalogos.doc(FS_COLLECTIONS.CAJAS)
            let cajas = CAJAS
            cajas.Cajas[0].sucursal = {
              id: refSucursal.id,
              nombre: sucursal.info.nombre,
              telefono: '555555'
            }
            cajas.Cajas[0].id_temporal=0
            refCajas.set(cajas)

            //Creamos una lista de colores a nivel franquicia
            let colores = refCatalogos.doc(FS_COLLECTIONS.PACIENTES)
            colores.set(COLORES)

            //Creamos una lista de estudios a nivel franquicia
            let estudios = refCatalogos.doc(FS_COLLECTIONS.ESTUDIOS)
            estudios.set(ESTUDIOS_BASE_OBJ.ESTUDIOS)

            let estudioBase = ESTUDIOS_BASE_OBJ.ESTUDIO;
            estudioBase.compartir.en_sucursales[refSucursal.id] = true;
            console.log(estudioBase);
            let estudio = refFranquicia
              .collection(FS_COLLECTIONS.ESTUDIOS)
              .doc('MmKoqqwyf7pekRa4hCz2')
            estudio.set(estudioBase);

            

            resolve(refSucursal.id)
            // Asignamos los servicios por deafault con el id de sucursal
          })
      })
    },
    cambiaStatusApp({ commit }, nuevoStatusApp) {
      commit('ASIGNA_STATUS_APP', nuevoStatusApp)
    },
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/usuarios/usuario.js